import React from 'react';
import { BookOpenIcon } from 'lucide-react';
export const Header = () => {
  return <header className="bg-gradient-to-r from-blue-600 to-indigo-700 shadow-md py-4 sticky top-0 z-10" data-id="element-68">
      <div className="container mx-auto px-4 flex items-center justify-between" data-id="element-69">
        <div className="flex items-center gap-3" data-id="element-70">
          <div className="bg-white text-blue-600 p-2 rounded-lg shadow-md" data-id="element-71">
            <BookOpenIcon size={24} data-id="element-72" />
          </div>
          <div data-id="element-73">
            <h1 className="text-xl font-bold text-white" data-id="element-74">
              Business Clarity DIY Audit Toolkit
            </h1>
            <p className="text-sm text-blue-100" data-id="element-75">
              From the Experts at Whole Square
            </p>
          </div>
        </div>
      </div>
    </header>;
};